import {
  ClipboardCheck,
  MessageCircle,
  FileCheck,
  ListChecks,
  MapPin,
} from 'lucide-react';
import { siteData } from '../../data/mock';
import { useInView } from '../../hooks/useInView';

const iconMap = {
  ClipboardCheck,
  MessageCircle,
  FileCheck,
  ListChecks,
  MapPin,
};

export const ValueBlocks = () => {
  const { valueBlocks } = siteData;
  const [ref, isInView] = useInView();

  return (
    <section className="py-[90px] lg:py-[110px] bg-[#edf5f2]">
      <div
        ref={ref}
        className={`max-w-[1200px] mx-auto px-6 lg:px-8 ${
          isInView ? 'animate-fade-in-up' : 'opacity-0'
        }`}
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 lg:gap-6">
          {valueBlocks.map((block, index) => {
            const Icon = iconMap[block.icon];
            return (
              <div
                key={index}
                className="group p-7 rounded-2xl bg-white/60 backdrop-blur-sm border border-white/60 hover:bg-white hover:shadow-[0_4px_20px_rgba(0,0,0,0.04)]"
                style={{
                  transition: 'background-color 0.35s, box-shadow 0.35s',
                }}
              >
                <div
                  className="w-11 h-11 rounded-xl bg-[#2d6a5a]/10 flex items-center justify-center mb-5 group-hover:bg-[#2d6a5a]/15"
                  style={{ transition: 'background-color 0.3s' }}
                >
                  {Icon && <Icon size={20} className="text-[#2d6a5a]" />}
                </div>
                <h3 className="font-heading text-[1.05rem] font-semibold text-stone-900 leading-snug">
                  {block.title}
                </h3>
                <p className="mt-2.5 text-[0.88rem] text-stone-500 leading-[1.7]">
                  {block.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
